module.exports = __webpack_public_path__ + "static/media/seasonal_riser_white.f48b36c5.svg";